<div class="contacts-container">
    <div class="contacts-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/mail_red.png" alt="users Icon" class="file-icon">
            <span class="header-title">
            <span class="title-text">Demandes de contact</span>

            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()" title="Retour à la liste">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>

    <div class="contact-details-container">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des détails du client...</p>
        </div>

        <!-- Error state -->
        <div *ngIf="!isLoading && errorMessage" class="error-state">
            <div class="error-icon">!</div>
            <p class="error-message">{{ errorMessage }}</p>
            <button class="retry-button" (click)="goToList()">Retour à la liste</button>
        </div>


        <div *ngIf="!isLoading && contact && !errorMessage" class="contact-card-container">
            <div class="contact-card">
                <div class="contact-content-col">
                    <div class="col-header">
                        <div class="left-side">
                            <h3 class="contact-title">{{ contact.fullName}} <span class="text-lowercase">&#x3C;{{ contact.email }}&#x3E;</span>
                            </h3>
                        </div>
                        <div class="right-side">
                            <div class="status-badge">
                                <span class="status-dot" [class.public]="contact.isRead" [class.private]="!contact.isRead"></span>
                                <span class="status-text">{{ contact.isRead ? 'Lu' : 'Non lu' }}</span>
                            </div>
                            <div *ngIf="contact.isArchived" class="status-badge">
                                <span class="status-dot private"></span>
                                <span class="status-text">Archivé</span>
                            </div>
                            <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                                <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                            </button>
                        </div>
                    </div>
                    <h2 class="contact-subject">{{contact.subject}}</h2>
                    <p class="contact-message">{{contact.message}}</p>
                    <div class="contact-footer">
                        <div class="creation-date">
                            crée le {{ contact.createdAt }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="popup-menu" *ngIf="menuOpen">
                <div class="arrow"></div>
                <ul>
                    <li *ngIf="!contact.isArchived" (click)="toggleVisibility()">
                        <img class="lock" src="./assets/images/icons/eye.png" alt="Visibility"> {{ contact.isRead ? 'Marquer comme non lu' : 'Marquer comme lu' }}
                    </li>
                    <li (click)="toggleArchive()">
                        <img class="lock" src="./assets/images/icons/archive.png" alt="Archiver"> {{ contact.isArchived ? 'Désarchiver' : 'Archiver' }}
                    </li>
                    <li *ngIf="!contact.isArchived" (click)="confirmDelete()" class="delete-item">
                        <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
                    </li>
                </ul>
            </div>

        </div>
    </div>
</div>

<div class="confirmation-modal-overlay" *ngIf="showDeleteModal && contact">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer cette demande <br><strong>"{{ contact.fullName  }}"</strong> (<small>{{contact.email}}</small>) </p>
            <p>"{{contact.subject}}"?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteContact()">Supprimer</button>
        </div>
    </div>
</div>